import mock from "@/@fake-db/mock";
/* eslint-disable global-require */
const data = {
  accountSetting: {
    general: {
      avatar: require("@/assets/images/portrait/small/avatar-s-11.jpg"),
      cover: require("@/assets/images/banner/banner-13.jpg"),
      username: "ali",
      fullName: "Muhammad Ali",
      email: "ali@fullstack.com",
      company: "Tech Digital",
    },
    info: {
      bio: "",
      dob: null,
      country: "Dubai",
      website: "",
      phone: 6562542568,
    },
    social: {
      socialLinks: {
        twitter: "https://www.twitter.com",
        facebook: "https://www.facebook.com/",
        google: "",
        linkedIn: "https://www.linkedin.com",
        instagram: "https://www.instagram.com/",
        quora: "",
        tiktok: "https://www.tiktok.com/en/",
        whatsapp1: "6562542568",
        whatsapp2: "9510829922",
        whatsapp3: "",
        whatsapp4: "",
      },
      connections: {
        twitter: {
          profileImg: require("@/assets/images/avatars/11-small.png"),
          id: "johndoe",
        },
        google: {
          profileImg: require("@/assets/images/avatars/3-small.png"),
          id: "luraweber",
        },
        facebook: {},
        github: {},
      },
    },
    notification: {
      commentOnArticle: true,
      AnswerOnForm: true,
      followMe: false,
      newAnnouncements: true,
      productUpdates: true,
      blogDigest: false,
    },
  },
};
/* eslint-disable global-require */
mock.onGet("/account-setting/data").reply(() => [200, data.accountSetting]);
